import React, { useEffect, useState } from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { TestimonialCard } from "../components/testimonial-card";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import {
  Star,
  Quote,
  Heart,
  Users,
  Award,
  ChevronRight
} from "lucide-react";

export default function TestimonialsPage() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch testimonials from WordPress
  useEffect(() => {
    async function loadTestimonials() {
      try {
        const response = await fetch(
          "/wp-json/wp/v2/testimonials?per_page=20"
        );

        const data = await response.json();
        console.log("TESTIMONIAL PAGE DATA:", data);

        setTestimonials(Array.isArray(data) ? data : []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
        setLoading(false);
      }
    }

    loadTestimonials();
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-primary/10 to-primary/5">
        <div className="container px-4 mx-auto text-center">
          <Badge className="mb-4">Patient Stories</Badge>

          <h1 className="mb-4 text-4xl font-bold md:text-5xl lg:text-6xl">
            What Our Patients Say
          </h1>

          <p className="max-w-2xl mx-auto mb-8 text-lg text-muted-foreground">
            Real experiences from real patients. Discover how Pranaam Hospitals
            has made a difference in their lives.
          </p>

          {/* Stats */}
          {/* <div className="grid grid-cols-2 gap-4 max-w-3xl mx-auto mt-12 md:grid-cols-4">
            <div className="text-center">
              <Users className="w-8 h-8 mx-auto mb-2 text-primary" />
              <div className="text-3xl font-bold text-primary">3+ Lacs</div>
              <p className="text-sm text-muted-foreground">Happy Patients</p>
            </div>

            <div className="text-center">
              <Star className="w-8 h-8 mx-auto mb-2 text-primary fill-primary" />
              <div className="text-3xl font-bold text-primary">4.8/5</div>
              <p className="text-sm text-muted-foreground">Average Rating</p>
            </div>

            <div className="text-center">
              <Heart className="w-8 h-8 mx-auto mb-2 text-primary" />
              <div className="text-3xl font-bold text-primary">98%</div>
              <p className="text-sm text-muted-foreground">Satisfaction Rate</p>
            </div>

            <div className="text-center">
              <Award className="w-8 h-8 mx-auto mb-2 text-primary" />
              <div className="text-3xl font-bold text-primary">500+</div>
              <p className="text-sm text-muted-foreground">Testimonials</p>
            </div>
          </div> */}
        </div>
      </section>

      {/* All Testimonials Grid */}
      <section className="py-16 bg-white">
        <div className="container px-4 mx-auto">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-3xl font-bold md:text-4xl">
              More Patient Experiences
            </h2>
            <p className="max-w-2xl mx-auto text-muted-foreground">
              Browse through hundreds of testimonials from patients across all
              our departments.
            </p>
          </div>

          {/* Loading State */}
          {loading && (
            <p className="text-center text-lg py-10">Loading testimonials...</p>
          )}

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {!loading &&
              testimonials.map((item, index) => (
                <TestimonialCard
                  key={index}
                  quote={item.acf?.patient_review}
                  name={item.acf?.patient_name}
                  title={item.acf?.treatment_related_}
                  image={item.acf?.image || "/placeholder.svg"}
                  rating={item.acf?.patient_rating || 5}
                />
              ))}
          </div>

          {!loading && (
            <div className="flex justify-center mt-12">
              <Button variant="outline" className="gap-2 bg-transparent">
                Load More Testimonials
                <ChevronRight className="w-4 h-4" />
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* Departments */}
      {/* <section className="py-16 bg-gray-100">
        <div className="container px-4 mx-auto">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-3xl font-bold md:text-4xl">
              Testimonials by Department
            </h2>
            <p className="max-w-2xl mx-auto text-muted-foreground">
              Explore patient experiences across our various medical
              specialties.
            </p>
          </div>

          <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-4">
            {[
              "Cardiology",
              "Orthopedics",
              "Neurology",
              "Pediatrics",
              "Maternity",
              "Gastroenterology",
              "Dermatology",
              "Pulmonology",
              "Plastic Surgery",
              "Psychology",
              "Urology",
              "ENT"
            ].map((dept) => (
              <Button
                key={dept}
                variant="outline"
                className="h-auto py-4 transition-all hover:bg-primary hover:text-white hover:border-primary"
              >
                {dept}
              </Button>
            ))}
          </div>
        </div>
      </section> */}

      {/* Share Experience Form */}
      {/* <section className="py-16 bg-white">
        <div className="container px-4 mx-auto">
          <div className="max-w-3xl mx-auto">
            <Card className="overflow-hidden border-2 border-primary/20">
              <div className="bg-gradient-to-r from-primary to-black p-8 text-white text-center">
                <Quote className="w-12 h-12 mx-auto mb-4" />
                <h2 className="mb-2 text-3xl font-bold">Share Your Experience</h2>
                <p className="text-white/90">
                  Your feedback helps us improve and inspires others to choose
                  quality healthcare.
                </p>
              </div>

              <CardContent className="p-8">
                <form className="space-y-6">
                  <div className="grid gap-6 md:grid-cols-2">
                    <div>
                      <label className="block mb-2 text-sm font-medium">
                        Your Name
                      </label>
                      <Input placeholder="Enter your name" />
                    </div>
                    <div>
                      <label className="block mb-2 text-sm font-medium">
                        Department
                      </label>
                      <Input placeholder="e.g., Cardiology" />
                    </div>
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-medium">
                      Email Address
                    </label>
                    <Input type="email" placeholder="your.email@example.com" />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-medium">
                      Rating
                    </label>
                    <div className="flex gap-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button key={star} type="button" className="hover:text-primary">
                          <Star className="w-8 h-8 text-gray-300 hover:text-primary hover:fill-primary" />
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-medium">
                      Your Testimonial
                    </label>
                    <Textarea
                      rows={6}
                      placeholder="Share your experience with us..."
                    />
                  </div>

                  <div className="flex items-start gap-2">
                    <input type="checkbox" className="mt-1" />
                    <label className="text-sm text-muted-foreground">
                      I consent to Pranaam Hospitals using my testimonial...
                    </label>
                  </div>

                  <Button className="w-full" size="lg">
                    Submit Testimonial
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <section className="py-16 bg-gray-100">
        <div className="container px-4 mx-auto">
          <Card className="overflow-hidden border-0 shadow-xl">
            <div className="bg-gradient-to-r from-primary to-black p-12 text-center text-white">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">
                Experience World-Class Healthcare
              </h2>
              <p className="mb-8 max-w-2xl mx-auto text-lg text-white/90">
                Join thousands of satisfied patients who trust Pranaam Hospitals
                for their healthcare needs.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button size="lg" variant="secondary">
                  <a href="/appointments">Book Appointment</a>
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-white text-primary hover:bg-white/90"
                >
                  <a href="/contact">Contact Us</a>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
}
